import React from "react";
import style from "./bar.module.css";
import { BarTask } from "../../../types/bar-task";

type BarDisplayProps = {
    x: number,
    y: number,
    width: number,
    height: number,
    isSelected: boolean,
    progressX: number,
    progressWidth: number,
    barCornerRadius: number,
    styles: {
        backgroundColor: string;
        backgroundSelectedColor: string;
        progressColor: string;
        progressSelectedColor: string;
    },
    onMouseDown: (event: React.MouseEvent<SVGPolygonElement, MouseEvent>) => void,
    task?: BarTask
};
export const BarDisplay: React.FC<BarDisplayProps> = ({
    task,
    x,
    y,
    width,
    height,
    isSelected,
    progressX,
    progressWidth,
    barCornerRadius,
    styles,
    onMouseDown,
}) => {
    const getProcessColor = () => {
        return isSelected ? styles.progressSelectedColor : styles.progressColor;
    };

    const getBarColor = () => {
        return isSelected ? styles.backgroundSelectedColor : styles.backgroundColor;
    };

    // Validate width values to prevent NaN
    const validWidth = isNaN(width) || width < 0 ? 0 : width;
    const validProgressWidth = isNaN(progressWidth) || progressWidth < 0 ? 0 : progressWidth;

    return (
        <g onMouseDown={onMouseDown}>
            <rect
                x={x}
                width={validWidth}
                y={y}
                height={height}
                ry={barCornerRadius}
                rx={barCornerRadius}
                fill={getBarColor()}
                className={style.barBackground}
            />
            <rect
                x={progressX}
                width={validProgressWidth}
                y={y}
                height={height}
                ry={barCornerRadius}
                rx={barCornerRadius}
                fill={getProcessColor()}
            />
            {task?.description && task?.description.length > 0 && (
                <foreignObject
                    x={x + width - height * 0.55}
                    y={y + height * 0.11}
                    width={height * 0.5}
                    height={height * 0.5}
                >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <i className="pi pi-info-circle" style={{ color: 'white', fontSize: `${height * 0.4}px` }} />
                    </div>
                </foreignObject>
            )}
        </g>
    );
};
